import { AutocompleteDemandAnalysisEntityType } from "../types/AutocompleteDemandAnalysisTypes";

/**
 * Text content constants for autocomplete demand analysis
 */
export const AUTOCOMPLETE_DEMAND_ANALYSIS_TEXT_CONTENT = {
    placeholderText: "demand_analysis.autocomplete.placeholder",
    placeholderBoldText: "",
} as const;

export const AUTOCOMPLETE_LIMIT_MODE = {
    limited: "limited",
    unlimited: "unlimited",
} as const;

export type AutocompleteLimitMode = (typeof AUTOCOMPLETE_LIMIT_MODE)[keyof typeof AUTOCOMPLETE_LIMIT_MODE];

// Total cap for no-query recents rendered as a single ungrouped list.
export const AUTOCOMPLETE_NO_QUERY_RECENTS_TOTAL_LIMIT = 20;

const ENTITY_RESULT_LIMITS = {
    [AutocompleteDemandAnalysisEntityType.ownList]: {
        [AUTOCOMPLETE_LIMIT_MODE.limited]: 3,
        [AUTOCOMPLETE_LIMIT_MODE.unlimited]: Infinity,
    },
    [AutocompleteDemandAnalysisEntityType.sharedList]: {
        [AUTOCOMPLETE_LIMIT_MODE.limited]: 3,
        [AUTOCOMPLETE_LIMIT_MODE.unlimited]: Infinity,
    },
    [AutocompleteDemandAnalysisEntityType.aiTopic]: {
        [AUTOCOMPLETE_LIMIT_MODE.limited]: 5,
        [AUTOCOMPLETE_LIMIT_MODE.unlimited]: 20,
    },
} as const;

export const getEntityLimit = (
    entityType: AutocompleteDemandAnalysisEntityType,
    limitMode: AutocompleteLimitMode,
): number => {
    return ENTITY_RESULT_LIMITS[entityType][limitMode];
};
